/* global fetch */

import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { Snapshot } from "../story-templates/snapshot";
import InfiniteStories from "./infinite-stories";
import { getInfiniteScrollApi, getInfiniteScrollConfigStyle } from "../../utils";
import "../../../assets/stylesheets/grid.scss";
import "./story.m.css";
import { getStoryComponent } from "../../component-bundles/bundling-utils";

export function StoryPageContent(data, config, renderStoryPageContent) {
  const { story, preview = false, index, staticRelatedStories } = data;
  const firstStory = index === 0;
  const infiniteScrollStyle = getInfiniteScrollConfigStyle(config);
  const showStoryTemplate = infiniteScrollStyle !== "read-more" || (infiniteScrollStyle === "read-more" && firstStory);
  if (!showStoryTemplate) return <Snapshot story={story} config={config} firstStory={firstStory} />;
  const props = {
    story: story,
    config: config,
    preview: preview,
    firstStory: firstStory,
    staticRelatedStories: staticRelatedStories,
    index: index
  };
  return (typeof renderStoryPageContent === "function" && renderStoryPageContent(props)) || null;
}

const getItemsWithComponent = items => {
  const updatedItems = items.map(async item => {
    const storyObj = item.story || item;
    const StoryComponent = await getStoryComponent(storyObj["story-template"]);
    return { story: storyObj, StoryComponent };
  });
  return updatedItems;
};

function storyPageLoadItems(pageNumber, story = {}, config = {}) {
  const infiniteScrollType = get(
    config,
    ["pagebuilder-config", "infiniteScroll", "infiniteScrollType"],
    get(config, ["theme-attributes", "infinite-scroll"], "")
  );
  const collectionSlug = get(config, ["theme-attributes", "infinite-scroll-collection"], "");
  const sectionId = get(story, ["sections", 0, "id"], null);
  const params = {
    pageNumber,
    sectionId,
    collectionSlug
  };
  let infiniteScrollApi = getInfiniteScrollApi(infiniteScrollType, params, config);
  return fetch(infiniteScrollApi)
    .then(response => {
      return response.json();
    })
    .then(async response => {
      const items = response.stories || response.items || [];
      const updatedItems = await Promise.all(getItemsWithComponent(items));
      return updatedItems;
    })
    .catch(err => {
      console.error("Error in retrieving infinite scroll stories :", err);
      return [];
    });
}

export class StoryPage extends React.Component {
  doAnalytics(story) {
    const { registerPageView } = require("@quintype/framework/client/analytics");
    registerPageView({ type: "story-page", story: story }, `/${story.slug}`);
  }

  render() {
    const infiniteScrollType = get(
      this.props.config,
      ["pagebuilder-config", "infiniteScroll", "infiniteScrollType"],
      get(this.props.config, ["theme-attributes", "infinite-scroll"], "")
    );
    const firstStory = this.index === 0;
    const infiniteScrollStyle = getInfiniteScrollConfigStyle(this.props.config);
    const showStoryTemplate =
      infiniteScrollStyle !== "read-more" || (infiniteScrollStyle === "read-more" && firstStory);

    if (this.props.preview || infiniteScrollType === "disabled") {
      return StoryPageContent(this.props.data, this.props.config, this.props.renderStoryPageContent);
    }
    return (
      <div className="infinite-wrapper">
        {!showStoryTemplate ? (
          <InfiniteStories
            {...this.props}
            renderStoryPageContent={this.props.renderStoryPageContent}
            loadItems={storyPageLoadItems}
            onItemFocus={item => console.log(`Story In View: ${item.story.headline}`)}
            onInitialItemFocus={item => this.doAnalytics(item.story)}
            doNotChangeUrl={true}
            neverHideItem={true}
          />
        ) : (
          <InfiniteStories
            {...this.props}
            renderStoryPageContent={this.props.renderStoryPageContent}
            loadItems={storyPageLoadItems}
            onItemFocus={item => console.log(`Story In View: ${item.story.headline}`)}
            onInitialItemFocus={item => this.doAnalytics(item.story)}
            neverHideItem={true}
          />
        )}
      </div>
    );
  }
}

StoryPageContent.propTypes = {
  config: PropTypes.object,
  data: PropTypes.shape({
    story: PropTypes.object,
    relatedStories: PropTypes.array,
    index: PropTypes.number,
    preview: PropTypes.bool
  })
};

StoryPage.propTypes = {
  preview: PropTypes.bool,
  config: PropTypes.object,
  renderStoryPageContent: PropTypes.any,
  data: PropTypes.shape({
    story: PropTypes.object,
    relatedStories: PropTypes.array,
    index: PropTypes.number,
    preview: PropTypes.bool
  })
};
